/** Shared with the web app, extension, and widget. Names never enter CSS directly. */
const gradients: ReadonlyArray<readonly [string, string]> = [
  ['#667eea', '#764ba2'],
  ['#f093fb', '#f5576c'],
  ['#4facfe', '#00f2fe'],
  ['#43e97b', '#38f9d7'],
  ['#f6d365', '#fda085'],
  ['#a18cd1', '#fbc2eb'],
  ['#84fab0', '#8fd3f4'],
  ['#fccb90', '#d57eeb'],
];

export function avatarGradient(seed: string): string {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) hash = (hash * 31 + seed.charCodeAt(i)) | 0;
  const pair = gradients[Math.abs(hash) % gradients.length]!;
  return `linear-gradient(135deg, ${pair[0]}, ${pair[1]})`;
}
